import type { QueryPagination } from 'components/Table/Pagination'
import { endpoints } from 'constants/endpoints'
import api from 'services/api'

import {
  toKeyAccountAddRequestData,
  toKeyAccountResponseData,
  toKeyAccountsResponseData,
  toKeyAccountTrackingResponse,
} from './adapters'
import type {
  KeyAccountAddRequestData,
  KeyAccountResponseData,
  KeyAccountResponseDataApi,
  KeyAccountsResponseData,
  KeyAccountsResponseDataApi,
  KeyAccountTrackingResponse,
  KeyAccountTrackingResponseApi,
} from './types'

export const getKeyAccountById = async (id: string): Promise<KeyAccountResponseData> => {
  const response = await api.get<KeyAccountResponseDataApi>(`${endpoints.keyAccounts}/${id}`)

  return toKeyAccountResponseData(response.data)
}

export const getKeyAccounts = async (): Promise<KeyAccountsResponseData> => {
  const response = await api.get<KeyAccountsResponseDataApi>(endpoints.keyAccounts)

  return toKeyAccountsResponseData(response.data)
}

export const getKeyAccountTracking = async (
  pagination: QueryPagination,
): Promise<KeyAccountTrackingResponse> => {
  const response = await api.get<KeyAccountTrackingResponseApi>(
    `${endpoints.keyAccountsTracking}`,
    {
      params: pagination,
    },
  )

  return toKeyAccountTrackingResponse(response.data)
}

export const addKeyAccount = async (id: string) => {
  const body = toKeyAccountAddRequestData(id)
  await api.post<KeyAccountAddRequestData>(endpoints.keyAccounts, body)
}

export const deleteKeyAccount = async (id: string) => {
  await api.delete(`${endpoints.keyAccounts}/${id}`)
}
